export enum MetadataMethodType {
  Manual = "Manual",
  File = "File",
  Automatic = "Automatic",
}
